<div class="card-base">
  <div class="card-content-reservation-search">

      <div class="chip-container">
          <mat-chip-list>
              <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                  {{ filt.valueView }}
                  <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
              </mat-chip>
          </mat-chip-list>
      </div>

      <div class="card-container mat-elevation-z1">
          <div class="clearfix">
              <div class="pull-left div-header-left">
                  <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                  <app-integrated-reception-admission-filter #filters></app-integrated-reception-admission-filter>
              </div>
          </div>
          <mat-divider></mat-divider>

          <div class="card-content margin-botton-medium">
              <p-scrollPanel styleClass="scroll-panel">
                  <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">

                      <ng-container matColumnDef="date">
                          <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                              <resizable-column-control width="150" tile="Fecha" #resColFecha></resizable-column-control>
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div><b>{{ element.DateTime | date: 'dd/MM/yyyy HH:mm' }}</b></div>
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="patientLasNameFirstName">
                          <div style="background-color:aquamarine">
                              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                  <resizable-column-control width="250" tile="Paciente" #resColPatient></resizable-column-control>
                              </th>
                              <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                  <div>{{ element.PatientLastNameFirstName }}</div>
                              </td>
                          </div>
                      </ng-container>

                      <ng-container matColumnDef="practiceRegionName">
                          <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                              <resizable-column-control width="200" tile="Práctica" #resColPractice></resizable-column-control>
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div>{{ element.PracticeRegionName }}</div>
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="equipmentName">
                          <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                              <resizable-column-control tile="Equipo" width="200" #resColEquipmentName></resizable-column-control>
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div> {{ element.EquipmentName }}</div>
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="isOverAppointment">
                          <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                              <resizable-column-control width="100" tile="Es sobreturno" #resIsOverAppointment></resizable-column-control>
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div>{{ element.IsOverAppointment ? 'Sí' : 'No'}}</div>
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="physicianLastNameFirstName">
                          <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                              <resizable-column-control width="200" tile="Médico actuante" #resColPhysicianLastNameFirstName></resizable-column-control>
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div>{{ element.PhysicianLastNameFirstName }}</div>
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="entityName">
                          <th class="search-table-header" mat-header-cell *matHeaderCellDef>
                              Entidad
                          </th>
                          <td (click)="patientAdmission(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                              <div> {{ element.EntityName }}</div>
                          </td>
                      </ng-container>

                      <!-- Star Column -->
                      <ng-container matColumnDef="star" stickyEnd>
                          <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                          <td class="search-table-cell" mat-cell *matCellDef="let element">
                              <button mat-icon-button [matMenuTriggerFor]="menuItem">
                <mat-icon>more_vert</mat-icon>
              </button>
                              <mat-menu #menuItem="matMenu">
                                  <button mat-menu-item (click)="patientAdmission(element)">
                  <mat-icon>perm_identity</mat-icon><span>Recepcionar</span>
                </button>
                              </mat-menu>
                          </td>
                      </ng-container>
                      <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
              </p-scrollPanel>
              <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
          </div>
      </div>
  </div>
</div>
